const data = {
    "年度专辑": [
        {
            "作品名称": "丑奴儿",
            "表演者": "草东没有派对",
            "制作人": "李孝祖",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/1.jpg"
        },
        {
            "作品名称": "飞行器的执行周期",
            "表演者": "郭顶",
            "制作人": "郭顶",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2.jpg"
        },
        {
            "作品名称": "周杰伦的睡前故事（周杰伦的床边故事）",
            "表演者": "周杰伦",
            "制作人": "周杰伦",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/3.jpg"
        },
        {
            "作品名称": "JTW西游记",
            "表演者": "方大同",
            "制作人": "方大同、张德铭、邹俊仁",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/4.jpg"
        },
        {
            "作品名称": "初学者",
            "表演者": "薛之谦",
            "制作人": "薛之谦/郑伟/赵英俊/Venk/郭顶/陈起贤",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/5.jpg"
        }
    ],
    "年度歌曲": [
        {
            "作品名称": "成都",
            "表演者": "赵雷",
            "作曲": "赵雷",
            "作词": "赵雷",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/6.jpg"
        },
        {
            "作品名称": "不将就",
            "表演者": "李荣浩",
            "作曲": "李荣浩",
            "作词": "李荣浩/黄伟文",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/7.jpg"
        },
        {
            "作品名称": "演员",
            "表演者": "薛之谦",
            "作曲": "薛之谦",
            "作词": "薛之谦",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/8.jpg"
        },
        {
            "作品名称": "悟空",
            "表演者": "方大同",
            "作曲": "方大同",
            "作词": "方大同",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/9.jpg"
        },
        {
            "作品名称": "大风吹",
            "表演者": "草东没有派对",
            "作曲": "草东没有派对",
            "作词": "草东没有派对",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/10.jpg"
        }
    ],
    "年度男歌手": [
        {
            "作品名称": "让我留在你身边、在这个世界相遇、I Do",
            "表演者": "陈奕迅",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/11.jpg"
        },
        {
            "作品名称": "JTW 西游记",
            "表演者": "方大同",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/12.jpg"
        },
        {
            "作品名称": "有理想",
            "表演者": "李荣浩",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/13.jpg"
        },
        {
            "作品名称": "飞行器的执行周期",
            "表演者": "郭顶",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/14.jpg"
        },
        {
            "作品名称": "今日营业中",
            "表演者": "林宥嘉",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/15.jpg"
        }
    ],
    "年度女歌手": [
        {
            "作品名称": "日常",
            "表演者": "田馥甄",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/16.jpg"
        },
        {
            "作品名称": "盛放",
            "表演者": "王璁",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/17.jpg"
        },
        {
            "作品名称": "小梦大半",
            "表演者": "陈粒",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/18.jpg"
        },
        {
            "作品名称": "野蛮生长",
            "表演者": "李宇春",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/19.jpg"
        },
        {
            "作品名称": "陪着我走",
            "表演者": "林忆莲",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/20.jpg"
        }
    ],
    "年度组合/团体": [
        {
            "作品名称": "陆垚知马俐、不语",
            "表演者": "火星电台",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/21.jpg"
        },
        {
            "作品名称": "永远都在",
            "表演者": "S.H.E",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/22.jpg"
        },
        {
            "作品名称": "萤火、是你、未来的进击",
            "表演者": "TFBOYS",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/23.jpg"
        },
        {
            "作品名称": "先生小姐",
            "表演者": "Mr. Miss",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/24.jpg"
        },
        {
            "作品名称": "双城记",
            "表演者": "上海彩虹室内合唱团",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/25.jpg"
        }
    ],
    "年度乐队": [
        {
            "作品名称": "丑奴儿",
            "表演者": "草东没有派对",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/26.jpg"
        },
        {
            "作品名称": "间听监",
            "表演者": "窦唯+译乐队",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/27.jpg"
        },
        {
            "作品名称": "自传",
            "表演者": "五月天",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/28.jpg"
        },
        {
            "作品名称": "花斑马",
            "表演者": "杭盖乐队",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/29.jpg"
        },
        {
            "作品名称": "LION",
            "表演者": "狮子合唱团",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/30.jpg"
        }
    ],
    "年度新人": [
        {
            "作品名称": "丑奴儿",
            "表演者": "草东没有派对",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/31.jpg"
        },
        {
            "作品名称": "冥明",
            "表演者": "苏运莹",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/32.jpg"
        },
        {
            "作品名称": "浓烟下的诗歌电台",
            "表演者": "陈鸿宇",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/33.jpg"
        },
        {
            "作品名称": "先生小姐",
            "表演者": "Mr. Miss",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/34.jpg"
        },
        {
            "作品名称": "大鱼、妳、临安初雨",
            "表演者": "周深",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/35.jpg"
        }
    ],
    "最佳流行专辑": [
        {
            "作品名称": "飞行器的执行周期",
            "表演者": "郭顶",
            "制作人": "郭顶",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/36.jpg"
        },
        {
            "作品名称": "周杰伦的睡前故事（周杰伦的床边故事）",
            "表演者": "周杰伦",
            "制作人": "周杰伦",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/37.jpg"
        },
        {
            "作品名称": "自传",
            "表演者": "五月天",
            "制作人": "五月天",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/38.jpg"
        },
        {
            "作品名称": "野蛮生长",
            "表演者": "李宇春",
            "制作人": "郑楠/陈伟伦/曲世聪/张亚东",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/39.jpg"
        },
        {
            "作品名称": "初学者",
            "表演者": "薛之谦",
            "制作人": "薛之谦/郑伟/赵英俊/Venk/郭顶/陈起贤",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/40.jpg"
        }
    ],
    "最佳流行演唱": [
        {
            "作品名称": "飞行器的执行周期",
            "表演者": "郭顶",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/41.jpg"
        },
        {
            "作品名称": "夏长",
            "表演者": "谭维维",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/42.jpg"
        },
        {
            "作品名称": "JTW 西游记 ",
            "表演者": "方大同",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/43.jpg"
        },
        {
            "作品名称": "让我留在你身边、在这个世界相遇、I Do",
            "表演者": "陈奕迅",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/44.jpg"
        },
        {
            "作品名称": "初学者 ",
            "表演者": "薛之谦",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/45.jpg"
        }
    ],
    "最佳摇滚专辑": [
        {
            "作品名称": "花斑马",
            "表演者": "杭盖乐队",
            "制作人": "Bob Ezrin/GGGarth/黎偌天（Rza Li）",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/46.jpg"
        },
        {
            "作品名称": "丑奴儿",
            "表演者": "草东没有派对",
            "制作人": "李孝祖",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/47.jpg"
        },
        {
            "作品名称": "钉子花",
            "表演者": "伍佰",
            "制作人": "伍佰",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/48.jpg"
        },
        {
            "作品名称": "自传",
            "表演者": "五月天",
            "制作人": "五月天",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/49.jpg"
        },
        {
            "作品名称": "LION",
            "表演者": "狮子合唱团",
            "制作人": "萧敬腾",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/50.jpg"
        }
    ],
    "最佳摇滚演唱": [
        {
            "作品名称": "灵魂歌手、喜剧、给我一点温度",
            "表演者": "梁博",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/51.jpg"
        },
        {
            "作品名称": "丑奴儿",
            "表演者": "草东没有派对",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/52.jpg"
        },
        {
            "作品名称": "自传",
            "表演者": "五月天",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/53.jpg"
        },
        {
            "作品名称": "键盘·狭、How do we find A way、低头士",
            "表演者": "黑豹乐队",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/54.jpg"
        },
        {
            "作品名称": "大爷门",
            "表演者": "信",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/55.jpg"
        }
    ],
    "最佳民谣专辑": [
        {
            "作品名称": "无法长大",
            "表演者": "赵雷",
            "制作人": "赵雷/喜子/姜北生",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/56.jpg"
        },
        {
            "作品名称": "浓烟下的诗歌电台",
            "表演者": "陈鸿宇",
            "制作人": "陈鸿宇",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/57.jpg"
        },
        {
            "作品名称": "小梦大半",
            "表演者": "陈粒",
            "制作人": "荒井十一",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/58.jpg"
        },
        {
            "作品名称": "心有花开",
            "表演者": "小娟&山谷里的居民",
            "制作人": "荒井十一",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/59.jpg"
        },
        {
            "作品名称": "我愚蠢的理想主义",
            "表演者": "阿肆",
            "制作人": "吴涛/荷画",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/60.jpg"
        }
    ],
    "最佳民谣演唱": [
        {
            "作品名称": "无法长大",
            "表演者": "赵雷",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/61.jpg"
        },
        {
            "作品名称": "小梦大半",
            "表演者": "陈粒",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/62.jpg"
        },
        {
            "作品名称": "浓烟下的诗歌电台",
            "表演者": "陈鸿宇",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/63.jpg"
        },
        {
            "作品名称": "我愚蠢的理想主义",
            "表演者": "阿肆",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/64.jpg"
        },
        {
            "作品名称": "心有花开",
            "表演者": "小娟&山谷里的居民",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/65.jpg"
        }
    ],
    "最佳民间/名族专辑": [
        {
            "作品名称": "花斑马",
            "表演者": "杭盖乐队",
            "制作人": "Bob Ezrin/GGGarth/黎偌天（Rza Li）",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/66.jpg"
        },
        {
            "作品名称": "Vavayan 女人",
            "表演者": "阿爆（阿仍仍）",
            "制作人": "荒井十一",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/67.jpg"
        },
        {
            "作品名称": "织谣",
            "表演者": "斯琴格日乐",
            "制作人": "斯琴格日乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/68.jpg"
        },
        {
            "作品名称": "龙图腾",
            "表演者": "阿普萨萨",
            "制作人": "张超",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/69.jpg"
        },
        {
            "作品名称": "天赋侗听",
            "表演者": "众艺人",
            "制作人": "百慕三石",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/70.jpg"
        }
    ],
    "最佳民间/民族演唱": [
        {
            "作品名称": "Vavayan 女人",
            "表演者": "阿爆（阿仍仍）",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/71.jpg"
        },
        {
            "作品名称": "织谣",
            "表演者": "斯琴格日乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/72.jpg"
        },
        {
            "作品名称": "织谣",
            "表演者": "内蒙古少年合唱团",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/73.jpg"
        },
        {
            "作品名称": "青春照相馆",
            "表演者": "玩具船长",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/74.jpg"
        },
        {
            "作品名称": "龙图腾",
            "表演者": "阿普萨萨",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/75.jpg"
        }
    ],
    "最佳舞曲/电音专辑": [
        {
            "作品名称": "间听监",
            "表演者": "窦唯+译乐队",
            "制作人": "窦唯",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/76.jpg"
        },
        {
            "作品名称": "黑金（Black & Golden ）",
            "表演者": "尚雯婕",
            "制作人": "尚雯婕/孔潇一",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/77.jpg"
        },
        {
            "作品名称": "梦游",
            "表演者": "Junglemico Project",
            "制作人": "MICO刘为",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/78.jpg"
        },
        {
            "作品名称": "The Road",
            "表演者": "黄子韬",
            "制作人": "黄子韬/王凯玉/王韵韵/Fki/Calvin C/Lena/Ceyli Jo/CHOPS/宫阁",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/79.jpg"
        },
        {
            "作品名称": "游园惊梦",
            "表演者": "白天不亮",
            "制作人": "白天不亮",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/80.jpg"
        }
    ],
    "最佳舞曲/电音演唱": [
        {
            "作品名称": "25LOOKS",
            "表演者": "G.E.M.邓紫棋",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/81.jpg"
        },
        {
            "作品名称": "黑金（Black & Golden ）",
            "表演者": "尚雯婕",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/82.jpg"
        },
        {
            "作品名称": "心电感应808、808、Dust My Shoulders Off",
            "表演者": "张靓颖",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/83.jpg"
        },
        {
            "作品名称": "I Can't Live Without You、 Take a ride、枪上膛的人",
            "表演者": "刘力扬",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/84.jpg"
        },
        {
            "作品名称": "The Road",
            "表演者": "黄子韬",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/85.jpg"
        }
    ],
    "最佳说唱专辑": [
        {
            "作品名称": "皇后区的皇后",
            "表演者": "葛仲珊",
            "制作人": "剃刀蒋",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/86.jpg"
        },
        {
            "作品名称": "午夜列车上的告别",
            "表演者": "Lu1、Cee",
            "制作人": "14?/Lu1/HARIKIRI/Posheric/蛋堡/白天不亮/SoundzImage/Octave20/Petechen/Snarelop",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/87.jpg"
        },
        {
            "作品名称": "27: 路西法密码",
            "表演者": "Kafe Hu",
            "制作人": "Kafe Hu/Soulspeak",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/88.jpg"
        },
        {
            "作品名称": "天兵",
            "表演者": "兄弟本色",
            "制作人": "梯依恩（TeN）/王淳一",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/89.jpg"
        }
    ],
    "最佳说唱表演": [
        {
            "作品名称": "皇后区的皇后",
            "表演者": "葛仲珊",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/90.jpg"
        },
        {
            "作品名称": "27: 路西法密码",
            "表演者": "Kafe Hu",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/91.jpg"
        },
        {
            "作品名称": "拽、城一哈、堵起",
            "表演者": "谢帝",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/92.jpg"
        },
        {
            "作品名称": "午夜列车上的告别",
            "表演者": "Lu1、Cee",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/93.jpg"
        },
        {
            "作品名称": "天兵",
            "表演者": "兄弟本色",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/94.jpg"
        }
    ],
    "最佳爵士专辑": [
        {
            "作品名称": "先生小姐",
            "表演者": "Mr. Miss",
            "制作人": "杜凯/戈非",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/95.jpg"
        },
        {
            "作品名称": "SEDAR",
            "表演者": "秦四风",
            "制作人": "秦四风",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/96.jpg"
        },
        {
            "作品名称": "爵觉",
            "表演者": "詹小栎",
            "制作人": "詹小栎",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/97.jpg"
        },
        {
            "作品名称": "谷萨诺瓦II——风带我走吧",
            "表演者": "谷峰",
            "制作人": "谷峰",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/98.jpg"
        },
        {
            "作品名称": "最初",
            "表演者": "李晓川",
            "制作人": "李晓川",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/99.jpg"
        }
    ],
    "最佳爵士演唱": [
        {
            "作品名称": "盛放",
            "表演者": "王璁",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/100.jpg"
        },
        {
            "作品名称": "爵觉",
            "表演者": "詹小栎",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/101.jpg"
        },
        {
            "作品名称": "谷萨诺瓦II——风带我走吧",
            "表演者": "谷峰",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/102.jpg"
        },
        {
            "作品名称": "先生小姐",
            "表演者": "Mr. Miss",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/103.jpg"
        }
    ],
    "最佳古典演绎专辑": [
        {
            "作品名称": "纽约狂想曲",
            "表演者": "郎朗",
            "制作人": "Larry Klein",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/104.jpg"
        },
        {
            "作品名称": "舒伯特",
            "表演者": "王弢",
            "制作人": "Dave Tam/Rainer Maillard",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/105.jpg"
        },
        {
            "作品名称": "勃拉姆斯：小提琴奏鸣曲1-3",
            "表演者": "谢楠、斯特凡·莱莫兰",
            "制作人": "王次炤",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/106.jpg"
        },
        {
            "作品名称": "多彩巴西",
            "表演者": "杨雪霏",
            "制作人": "杨雪霏",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/107.jpg"
        },
        {
            "作品名称": 15,
            "表演者": "欧阳娜娜",
            "制作人": "Sunny Fu/DaveTam",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/108.jpg"
        }
    ],
    "最佳古典原创专辑": [
        {
            "作品名称": "双城记",
            "表演者": "上海彩虹室内合唱团、崔薇、金承志",
            "制作人": "金承志",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/109.jpg"
        },
        {
            "作品名称": "白山松水图",
            "表演者": "吉林省民族乐团、史志有",
            "制作人": "谭沛先",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/110.jpg"
        },
        {
            "作品名称": "Hybrid Orchestra Music of Stephen Yang（杨天光交响风格音乐集）",
            "表演者": "杨天光",
            "制作人": "杨天光",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/111.jpg"
        },
        {
            "作品名称": "神话",
            "表演者": "众艺人、张朝",
            "制作人": "叶云川",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/112.jpg"
        },
        {
            "作品名称": "黄河壁画",
            "表演者": "山西省交响乐团、迈克·科勒（指挥）、王西麟",
            "制作人": "谭沛先",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/113.jpg"
        }
    ],
    "最佳影视/游戏原声专辑": [
        {
            "作品名称": "老炮儿（电影原声带）",
            "表演者": "众艺人、窦鹏",
            "制作人": "窦鹏",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/114.jpg"
        },
        {
            "作品名称": "不语（《不速之客》电影原声带）",
            "表演者": "火星电台",
            "制作人": "火星电台",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/115.jpg"
        },
        {
            "作品名称": "致青春：原来你还在这里（影视原声带）",
            "表演者": "群星、王铮亮",
            "制作人": "王铮亮",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/116.jpg"
        },
        {
            "作品名称": "那年青春我们正好（电视剧原声带）",
            "表演者": "群星",
            "制作人": "王铮亮/闫天午",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/117.jpg"
        },
        {
            "作品名称": "海洋奇缘（中文版电影原声带）",
            "表演者": "群星",
            "制作人": "陈少琪",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/118.jpg"
        }
    ],
    "最佳作词": [
        {
            "作品名称": "大风吹",
            "表演者": "草东没有派对",
            "作词": "草东没有派对",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/119.jpg"
        },
        {
            "作品名称": "演员",
            "表演者": "薛之谦",
            "作词": "薛之谦",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/120.jpg"
        },
        {
            "作品名称": "生活不止眼前的苟且",
            "表演者": "许巍",
            "作词": "高晓松",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/121.jpg"
        },
        {
            "作品名称": "天真有邪",
            "表演者": "林宥嘉",
            "作词": "黄伟文",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/122.jpg"
        },
        {
            "作品名称": "成名在望",
            "表演者": "五月天",
            "作词": "阿信@五月天",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/123.jpg"
        }
    ],
    "最佳作曲": [
        {
            "作品名称": "大风吹",
            "表演者": "草东没有派对",
            "作曲": "草东没有派对",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/124.jpg"
        },
        {
            "作品名称": "演员",
            "表演者": "薛之谦",
            "作曲": "薛之谦",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/125.jpg"
        },
        {
            "作品名称": "水星记",
            "表演者": "郭顶",
            "作曲": "郭顶",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/126.jpg"
        },
        {
            "作品名称": "告白气球",
            "表演者": "周杰伦",
            "作曲": "周杰伦",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/127.jpg"
        },
        {
            "作品名称": "感觉身体被掏空",
            "表演者": "彩虹合唱团",
            "作曲": "金承志",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/128.jpg"
        }
    ],
    "最佳制作": [
        {
            "作品名称": "周杰伦的睡前故事（周杰伦的床边故事）",
            "表演者": "周杰伦",
            "制作人": "周杰伦",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/129.jpg"
        },
        {
            "作品名称": "飞行器的执行周期",
            "表演者": "郭顶",
            "制作人": "郭顶",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/130.jpg"
        },
        {
            "作品名称": "Baby ，До свидания (达尼亚)",
            "表演者": "朴树",
            "制作人": "张亚东",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/131.jpg"
        },
        {
            "作品名称": "贼",
            "表演者": "戴佩妮",
            "制作人": "戴佩妮",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/132.jpg"
        },
        {
            "作品名称": "少女进化论",
            "表演者": "SNH48",
            "制作人": "上海丝芭文化",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/133.jpg"
        }
    ],
    "最佳编曲": [
        {
            "作品名称": "大风吹",
            "表演者": "草东没有派对",
            "编曲": "草东没有派对",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/134.jpg"
        },
        {
            "作品名称": "凄美地",
            "表演者": "郭顶",
            "编曲": "郭顶",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/135.jpg"
        },
        {
            "作品名称": "花斑马",
            "表演者": "杭盖乐队",
            "编曲": "杭盖乐队",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/136.jpg"
        },
        {
            "作品名称": "告白气球",
            "表演者": "周杰伦",
            "编曲": "林迈可",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/137.jpg"
        },
        {
            "作品名称": "悟空",
            "表演者": "方大同",
            "编曲": "方大同/Derrick Sepnio",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/138.jpg"
        }
    ],
    "最佳录音": [
        {
            "作品名称": "悟空",
            "表演者": "方大同",
            "录音师": "Derrick Sepnio",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/139.jpg"
        },
        {
            "作品名称": "飞行器的执行周期",
            "表演者": "郭顶",
            "录音师": "卢楠/ 郭顶",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/140.jpg"
        },
        {
            "作品名称": "间听监",
            "表演者": "窦唯+译乐队",
            "录音师": "单晓帆、罗皓",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/141.jpg"
        },
        {
            "作品名称": "告白气球",
            "表演者": "周杰伦",
            "录音师": "杨瑞代",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/142.jpg"
        },
        {
            "作品名称": "花斑马",
            "表演者": "杭盖乐队",
            "录音师": "Ben Kaplan、Rza Li（黎偌天）、GGGarth、Justin Cortelyou、Karl Dicaire",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/143.jpg"
        }
    ],
    "最佳混音": [
        {
            "作品名称": "间听监",
            "表演者": "窦唯+译乐队",
            "混音师": "罗皓",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/144.jpg"
        },
        {
            "作品名称": "飞行器的执行周期",
            "表演者": "郭顶",
            "混音师": "卢楠",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/145.jpg"
        },
        {
            "作品名称": "SEDAR",
            "表演者": "秦四风",
            "混音师": "Goh Hotoda、秦四风、马力",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/146.jpg"
        },
        {
            "作品名称": "告白气球",
            "表演者": "周杰伦",
            "混音师": "林邁可",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/147.jpg"
        },
        {
            "作品名称": "花斑马",
            "表演者": "杭盖乐队",
            "混音师": "Justin Cortelyou, Bob Ezrin",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/148.jpg"
        }
    ],
    "最佳唱片设计": [
        {
            "作品名称": "丑奴儿",
            "表演者": "草东没有派对",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/149.jpg"
        },
        {
            "作品名称": "飞行器的执行周期",
            "表演者": "郭顶",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/150.jpg"
        },
        {
            "作品名称": "有理想",
            "表演者": "李荣浩",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/151.jpg"
        },
        {
            "作品名称": "我愚蠢的理想主义",
            "表演者": "阿肆",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/152.jpg"
        },
        {
            "作品名称": "樂藏·阿里",
            "表演者": "西藏民间艺人",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/153.jpg"
        }
    ]
}

export default data